import React from 'react';
// import Downshift from 'downshift';
import { Flex, Box } from '@rebass/grid';
import { queryCache } from 'react-query';
import ComponentsTree from 'components/ComponentTree';
import { useComponentStatuses } from 'shared/hooks';
import request from 'helpers/request';
import { navigate } from '@reach/router';
// import { FormButton } from 'components/Buttons';
// import isEqual from 'lodash.isequal'
import { Button, Drawer, DrawerBody } from 'freemium-ui';
import { STATUSOPTIONS } from 'screens/incidents/constants';
import { useTranslation } from 'react-i18next';
import Icon from '../Icons';
import { DropdownMenu, FooterDrawer } from './style';
// import { MOCK_COMPONENTS } from '../FormikField/AffectedField';
// import { PlainTree } from '../Tree';
// import { TooltipWrapper } from '../GlobalSideNav/style';
import QuickStatusMenu from './QuickStatusMenu';
import i18n from '../../i18n';

// const defaultItemToString = item => (item === null ? '' : String(item));

export const Footer = ({ toggleMenu, isEnabled, changeStatus }) => {
  const trans = i18n.t;
  return (
    <Flex justifyContent="space-between" padding="1" width="100%">
      <Box mr="2" py="2">
        <Button type="secondary" onClick={toggleMenu}>
          {trans('components.changeComponentStatus.buttonCancel')}
        </Button>
      </Box>
      <Box py="2">
        <Button type="primary" disabled={!isEnabled} onClick={changeStatus}>
          {trans('components.changeComponentStatus.buttonSetService')}
        </Button>
      </Box>
    </Flex>
  );
};

const ChangeComponentStatus = () => {
  const { t } = useTranslation();
  const { data: components, isFetching, refetch } = useComponentStatuses();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const [changes, setChanges] = React.useState([]);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const componentState = isFetching ? 'loading' : 'success';

  const handleComponentsChange = formChange => {
    let affectedComponents = Object.keys(formChange).filter(
      eachComponent => formChange[eachComponent].selected
    );
    affectedComponents = affectedComponents.map(eachComponent => ({
      component: String(formChange[eachComponent].component),
      new_status: formChange[eachComponent].status
    }));
    const change = affectedComponents
      .map(eachComponent => formChange[eachComponent.component])
      .filter(affectedComponent => {
        const c = components.find(
          comp => comp.component === affectedComponent.component
        );
        return c && c.status !== affectedComponent.status;
      });
    if (change.length) {
      setChanges(
        change.map(c => ({
          component: c.component.toString(),
          new_status: c.status
        }))
      );
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const handleSubmit = async () => {
    await request('/bulk-component-updates/', {
      method: 'POST',
      payload: changes
    });

    Object.keys(queryCache.queries)
      .filter(query => /\["status-changes"/.test(query))
      .forEach(key => {
        if (queryCache.queries[key]) queryCache.queries[key].refetch();
      });

    setIsDrawerOpen(false);
    navigate(`/admin/quick-status`);
  };

  return (
    <div>
      {/* <Button
        inline
        size="normal"
        type="secondary"
        onClick=
        style={{ height: '32px', marginRight: '12px' }}
      >
        Change service status
      </Button> */}
      <QuickStatusMenu
        openQuickChange={() => {
          setIsDrawerOpen(true);
          if (!isDrawerOpen) {
            refetch();
          }
        }}
      />
      <Drawer
        isOpen={isDrawerOpen}
        onDismiss={() => setIsDrawerOpen(false)}
        isFullHeight
        placement="right"
      >
        <DrawerBody
          style={{
            padding: 0
          }}
        >
          <DropdownMenu componentsState={componentState}>
            <div className="loader" />
            <div className="notice">
              <Icon glyph="info" viewBox="0 -5 20 20" />
              {t('components.changeComponentStatus.statusMessage')}
            </div>
            <Box
              css={{
                overflow: 'auto',
                flex: '1',
                padding: '0 10px 25px'
              }}
            >
              {components && (
                <ComponentsTree
                  compact
                  title={t(
                    'components.changeComponentStatus.changeServiceStatus'
                  )}
                  isDrawer
                  components={components}
                  statusOptions={STATUSOPTIONS}
                  actionCallback={compObj => {
                    handleComponentsChange(compObj);
                  }}
                />
              )}
              {/* <PlainTree
                  
                  toggleStatusChange={this.toggleStatusChange}
                /> */}
            </Box>
            <FooterDrawer>
              <Footer
                isEnabled={!isDisabled}
                toggleMenu={() => setIsDrawerOpen(!isDrawerOpen)}
                changeStatus={() => {
                  handleSubmit();
                }}
              />
            </FooterDrawer>
          </DropdownMenu>
        </DrawerBody>
      </Drawer>
    </div>
  );
};

export default ChangeComponentStatus;
